import logo from "../../assets/logo.png";

import november1 from "../../assets/NEWS/november2023/1.jpg";
import november2 from "../../assets/NEWS/november2023/11.jpg";
import november3 from "../../assets/NEWS/november2023/111.jpg";
import november4 from "../../assets/NEWS/november2023/1111.jpg";

import september1 from "../../assets/NEWS/september2023/2.jpg";
import september2 from "../../assets/NEWS/september2023/22.jpg";
import september3 from "../../assets/NEWS/september2023/222.jpg";

import june1 from "../../assets/NEWS/june2023/31.jpg";
import june2 from "../../assets/NEWS/june2023/3.jpg";
import june3 from "../../assets/NEWS/june2023/32.jpg";
import june4 from "../../assets/NEWS/june2023/33.jpg";
import june5 from "../../assets/NEWS/june2023/34.jpg";
import june6 from "../../assets/NEWS/june2023/333.jpg";
import june7 from "../../assets/NEWS/june2023/3333.jpg";
import june8 from "../../assets/NEWS/june2023/33333.jpg";
import { NewsItem } from "../../shared/types";

const news: NewsItem[] = [
  {
    title: "Dream Innovation joins the AEROSPACE & DEFENSE Meetings Torino!",
    date: "November 28-30th, 2023",
    content:
      "Aerospace & Defense Meetings will be held from 28 to 30 November 2023 at the Oval Lingotto of Lingotto Fiere in Turin, organized by abe – BCI Aerospace and promoted by the Piedmont Region and the Turin Chamber of Commerce. This is the 9th edition of the only international business convention for the aerospace and defense industry in Italy, whose program includes side events, workshops, sessions on procurement and subcontracting policy, seminars on innovation and high-level conferences in- depth inherent to issues of importance for the aerospace sector. A&DM Torino is a dynamic platform, aimed at consolidating attention, dialogue and comparison between large industries, SMEs and start-ups, universities and international research centers in the aerospace panorama. For this edition, the convention will have as main themes: Space: Return to the Moon – launchers, human space exploration, robotics/automation.  Industry 5.0: artificial intelligence.  Defense: Cyber Security/FCAS, new generation cargo aircraft and helicopters.  Green Aviation: electrification and related technologies.  The 2023 edition will see the renewed participation of top space players alongside aeronautical ones, interested in the consolidated excellence typical of the region and innovative products linked to the Space Economy. The Italians Leonardo, Thales Alenia Space, Avio Aero and Collins Aerospace will be present. From the international scene, however: Boeing International Turkey, Airbus Defense & Space, Collins Aerospace Poland, IAI, Aernnova, Kanematsu Germany, TUSAS Engine Industries (TEI), Lookheed Martin Space Systems, Mohamed Bin Rashid Space Center, Comac European Office, National Space Facility Control & Test center, Swissprt International, OLEDCOM.",
    link: "",
    images: [november1, november2, november3, november4],
    shortContent:
      "Dream Innovation invited to the Aerospace & Defence Meetings Torino within the collective organized by the Campania Region.",
  },
  {
    title:
      "Dream invited at 13th EASN International Conference to present  MYTHOS project",
    date: "September 05-08th, 2023",
    content:
      "Dream invited at 13th EASN International Conference to present  MYTHOS project. September 05-08th, 2023 'Dream was invited at EASN Conference in Salerno to present the main objectives and outcomes of MYTHOS HE project'. Dream Innovation Srl joined the 13th EASN International Conference with the following presentations - 'Propeller-Wing Interaction: A Simplified Method for Coupling BEM and CFD' presented by Umberto Merola (co-authors: Serena Russo, Nunzio Natale) - 'Propeller wake impact on transition location' presented by Serena Russo (co-author: Flavio Giannetti). Moreover, Nunzio Natale presented the main objectives and outcomes of MYTHOS HE project. The conference is considered one of the major European Dissemination and Exploitation event of Aviation & Space related research, as it provides a forum for presenting their activities and achieved goals, discussing current trends and future needs of aviation & space-related research, and trying to identify possible synergies with each other. Additionally, several policy development projects will also find the floor to present the strategic priorities of the European aviation sector. The 13th EASN International Conference included several Plenary Talks by distinguished personalities of the European Aviation and Space sectors from the academia, industry, research community, and policymakers. The event will also give the opportunity to scientists and researchers from all over the world to present their recent achievements in a series of thematic sessions, organized by internationally recognized scientists.",
    link: "https://forschung.ruhr-uni-bochum.de/en/mythos",
    images: [september1, september2, september3],
    shortContent:
      "Dream was invited at EASN Conference in Salerno to present the main objectives and outcomes of MYTHOS HE project",
    dissemination: {
      text: "We are glad to announce the publication of the Conference Proceedings Issue, i.e.",
      urls: [
        {
          name: "Serena Russo and Flavio Giannetti 2024 J. Phys.: Conf. Ser. 2716 012006",
          url: "https://iopscience.iop.org/article/10.1088/1742-6596/2716/1/012006"
        },   
        {
          name: "Umberto Merola et al 2024 J. Phys.: Conf. Ser. 2716 012005",
          url: "https://iopscience.iop.org/article/10.1088/1742-6596/2716/1/012005"
        }, 
      ],
    },
  },

  {
    title: "Successfull partecipation to Paris Le Bourget Air Show!",
    date: "June 19-25th, 2023",
    content:
      "The objective of the collective was to create a link between the different realities, as well as to promote the products and technologies of the entire sector at an international level. The day began with the inauguration of the Campania Region stand (Hall 1 G 299), in the presence of the Regional Councilor for Research, Innovation and Start UP, Valeria Fascione, and the General Director of the D.G. Economic Development and Productive Activities of the Campania Region, Raffaella Farina, the President of CIRA, Antonio Blandini, the President of the DAC (Aerospace Technological District), Luigi Carrino, and the President of Unioncamere, Andrea Prete. Important institutional meetings followed, including the visit of the Italian Minister of Defense Guido Crosetto and a series of meetings within the European Sesar3 and Clean Aviation programmes, of which CIRA became a founding member as well as being actively involved in various projects financed by both.",
    link: "",
    images: [june1, june2, june3, june4, june5, june6, june7, june8],
    shortContent:
      "From 19 to 25 June, Dream Innovation participated to the International Paris Air Show of Le Bourget within the collective organized by the Campania Region to promote competitiveness and innovation of aerospace companies.",
  },
  {
    title: "Dream Innovation Shines at MYTHOS Kick-off in Brussels!",
    date: "April 12th, 2023",
    content:
      "Dream Innovation attended the MYTHOS kick-off meeting in Bruxelles.",
    link: "",
    images: [],
    shortContent: "",
  },
  {
    title: "Dream Innovation Joins MYTHOS Virtual Kick-off!",
    date: "February, 2023",
    content:
      "Dream Innovation attended the virtual kick-off meeting of MYTHOS.",
    link: "",
    images: [],
    shortContent: "",
  },
  {
    title: "AMBER Kick-off: Dream Innovation in Turin!",
    date: "January 23-24th, 2023",
    content: "Dream Innovation attended the AMBER kick-off meeting in Turin.",
    link: "",
    images: [],
    shortContent: "",
  },
  {
    title: "NEUMANN Kick-off: Dream Innovation in Turin!",
    date: "February 22-23th, 2023",
    content: "Dream Innovation attended the NEUMANN kick-off meeting in Turin.",
    link: "",
    images: [],
    shortContent: "",
  },

  {
    title: "HERA Kick-off: Dream Innovation in Naples!",
    date: "January 30-31th, 2023",
    content: "Dream Innovation attended the HERA kick-off meeting in Naples.",
    link: "",
    images: [],
    shortContent: "",
  },
  {
    date: "April, 2022",
    title: "An accurate RANS-based transition prediction approach (part I)",
    content:
      "Dream Innovation published the paper in the IOP Conference Series: Materials Science and Engineering™.",
    link: "https://iopscience.iop.org/article/10.1088/1757-899X/1226/1/012012",
    images: [],
    shortContent: "",
  },
  {
    date: "April, 2022",
    title: "An accurate RANS-based transition prediction approach (part II)",
    content:
      "Dream Innovation published the paper in the IOP Conference Series: Materials Science and Engineering™.",
    link: "https://iopscience.iop.org/article/10.1088/1757-899X/1226/1/012013",
    images: [],
    shortContent: "",
  },
  {
    date: "April, 2022",
    title: "Aerodynamic Analysis of a scaled UHBR Fan",
    content:
      "Dream Innovation published the paper in the IOP Conference Series: Materials Science and Engineering™.",
    link: "https://iopscience.iop.org/article/10.1088/1757-899X/1226/1/012007",
    images: [],
    shortContent: "",
  },
  {
    date: "April, 2022",
    title:
      "The preliminary design of a scaled Composite UHBR Fan for a wind tunnel test campaign",
    content:
      "Dream Innovation published the paper in the IOP Conference Series: Materials Science and Engineering™.",
    link: "https://iopscience.iop.org/article/10.1088/1757-899X/1226/1/012041",
    images: [],
    shortContent: "",
  },
  {
    date: "November, 2021",
    title: "Dream Innovation attended the DubaiAirShow 2021!",
    content: "Dream Innovation attended the DubaiAirShow 2021!",
    link: "https://www.dubaiairshow.aero/exhibitor/dream-innovation-srl",
    images: [],
    shortContent: "",
  },
  {
    date: "April, 2021",
    title:
      "A CFD study on the strut interference on a regional aircraft wind-tunnel model",
    content:
      "Dream Innovation published the paper in the IOP Conference Series: Materials Science and Engineering™.",
    link: "https://iopscience.iop.org/article/10.1088/1757-899X/1024/1/012047/meta",
    images: [],
    shortContent: "",
  },
  {
    date: "November, 2020",
    title: "Dream Innovation is on Skyline 30",
    content:
      "Dream Innovation is on Skyline 30. In this number Clean sky put the spotlight on #SMEs, who make up 37% of our partners!",
    link: "https://www.clean-aviation.eu/sites/default/files/2021-08/Skyline30_en.pdf",
    images: [],
    shortContent: "",
  },
  // Add more news items as needed
];

export default news;
